import React from 'react';

const termsData = [
    {
       
        title: "1. Project Approval and Document Verification",
        content: "The Mr.Housing India Iris Resort project is a DTCP and RERA approved venture. All buyers must ensure that all necessary project documents are verified before making any purchases."
    },
    {
      
        title: "2. Resort Amenities and Construction Phases",
        content: "The resort amenities, including water cottages, villa cottages, suite rooms, and various leisure facilities, are under construction. These may be completed in different phases as per the project timeline."
    },
    {
        id: 3,
        title: "3. Bank Loans",
        content: "Bank loans of up to 80% are available for buyers from select financial institutions, subject to eligibility criteria set by those institutions."
    }, 
    {
     
        title: "4. Delays and Responsibilities",
        content: "Mr.Housing India Iris Resort will not be liable for delays caused by unforeseen circumstances, including legal, regulatory, or environmental changes that may impact the project timeline or construction activities."
    }, 
    {
      
        title: "5. Representational Images and Variations",
        content: "All images, designs, and layouts provided on the website or promotional materials are for representational purposes only. The actual construction and design may vary from the displayed visuals."
    }, 
    {
     
        title: "6. Maintenance of Common Areas",
        content: "The maintenance of common areas such as roads, parks, utilities, and other shared spaces will follow the guidelines set out in the sale agreement."
    },
     {
      
        title: "7. Location and Accessibility",
        content: "The Mr.Housing India Iris Resort is strategically located near key landmarks, including Woxsen International University, the NIMZ SEZ, and upcoming infrastructure projects. However, travel times to these locations may vary depending on traffic conditions."
    }, 
    {
      
        title: "8. Buyer Due Diligence",
        content: "Buyers are encouraged to conduct thorough due diligence before proceeding with any purchases. This includes verifying all necessary project-related approvals, certifications, and legal documents."
    },
     {
       
        title: "9. Tie-up with Lemon Tree Hotels",
        content: "The resort amenities include a tie-up with Lemon Tree Hotels for providing hotel services. This partnership is subject to contract agreements and may evolve over time."
    },
     {
        title: "10. Acceptance of Terms",
        content: "By proceeding with any transactions related to the Mr.Housing India Iris Resort project, you acknowledge and accept these Terms and Conditions, which govern the sale and purchase process."
    },
     {
        title: "Disclaimer",
        content: "The site is provided on an 'as-is' and 'as-available' basis. You agree that your use of the site services will be at your own risk. To the fullest extent permitted by law, we disclaim all warranties, express or implied, including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We make no representations or warranties about the accuracy or completeness of the content on the site, or the content of any websites linked to this site. We assume no liability for any errors, mistakes, or inaccuracies of content and materials, personal injury, property damage, unauthorized access to secure servers, bugs, viruses, or any other issues that may arise from the use of the site."
    },
     {
        title: "Limitations of Liability",
        content: "Under no circumstances will we or our directors, employees, or agents be liable to you or any third party for any direct, indirect, consequential, exemplary, incidental, special, or punitive damages, including lost profits, data loss, or any damages arising from your use of the site, even if we have been advised of the possibility of such damages. Our liability to you, for any cause of action, will always be limited to the amount you paid to us for use of the site or services.",
        content1: "Certain jurisdictions may not allow limitations on implied warranties or exclusions of damages, so some of these limitations may not apply to you."
    },
     {
        title: "Indemnification",
        content: "You agree to defend, indemnify, and hold us harmless from any claim, loss, damage, liability, or demand, including reasonable attorneys' fees, arising from your use of the site, violation of these terms, or infringement of any third-party rights. You will cooperate with us in defending any such claim."
    }, 
    {
       
        title: "User Data",
        content: "We maintain certain data that you provide for managing site performance. While we regularly back up data, you are responsible for ensuring the safety of any data you transmit. We do not guarantee against data loss and will not be liable for any loss or corruption of such data."
    }, 
    {
        
        title: "Electronic Communications, Transactions, and Signatures",
        content: "By accessing or using this site, you consent to receive electronic communications from us. You agree that all communications, including agreements, notices, and disclosures, satisfy any legal requirements that such communication be in writing. You agree to the use of electronic signatures in connection with any transactions on the site."
    }, 
    {
       
        title: "Miscellaneous",
        content: "These Terms of Use and the policies posted on the site constitute the complete and exclusive understanding between you and us. If we fail to enforce any part of these Terms, it shall not be considered a waiver. If any provision is found to be unlawful or unenforceable, the remaining provisions will remain valid. You agree that these Terms will not be construed against us because we wrote them."
    }, 
    {
      
        title: "Contact Us",
        content: "For questions or to resolve complaints regarding the site or use of the services, please contact us:",
        content1: "Mr.Housing India Iris Resort"
    },
];

function TermsAndConditions() {
    return (
        <div>
            <div className='pt-[2%]'>
                <h1 className='text-center text-[1.5rem] text-[#3D52A1] font-bold'>Terms and Conditions</h1>
            </div>
            <div className='text-[16px] font-normal max-w-1440 w-full mx-auto xl:px-[5vh] lg:px-[2vh] px-[1vh] py-[10px]'>
                {termsData.map(term => (
                    <div className='my-3'>
                        <h1 className='font-bold text-[#3D52A1] text-[20px]'> {term.title}</h1>
                        <p>{term.content}</p>
                        <p>{term.content1}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TermsAndConditions;
